import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import moment from "moment";
import { useHistory } from "react-router-dom";

const AddPayeePendingApproval = (params) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const addPayeePendingApprovalData = useSelector(
    (state) => state?.orderInvoicesReducer?.addPayeePendingApprovalData
  );

  useEffect(() => {
    dispatch(actions?.addPayeePendingApprovalData());
  }, []);

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content row mx-0 new-payee">
          <div className="container px-0">
            <div class="finance-setting-chart chart-of-accounts payees-master top-header-sec">
              <div class="row-fluid">
                <div class="shadowclass padding_b">
                  <div class="span12">
                    <h4 class="event-alert text-green">
                      Add Payee Pending Approval
                      <a class="print-cammond" href="#"></a>
                      <div class="clear"></div>
                    </h4>
                    <div class="row-fluid">
                      <div class="span4">
                        <div class="search-box">
                          <input
                            type="text"
                            placeholder="Search"
                            name="search_tag"
                            id="PayeeSearchTag"
                          />
                          <input type="submit" onclick="return false;" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row-fluid text-right-last">
                <div class="span12">
                  <div class="shadowclass padding_b">
                    <div class="inner-space screen-scroll mCustomScrollbar _mCS_3">
                      <div
                        class="mCustomScrollBox mCS-light mCSB_horizontal"
                        id="mCSB_3"
                      >
                        <div class="mCSB_container">
                          <form
                            action="/finance_settings/approve_temp_payees"
                            id="FinancePayeesTempAddPayeePendingApprovalForm"
                            method="post"
                            accept-charset="utf-8"
                          >
                            <div>
                              <input
                                type="hidden"
                                name="_method"
                                value="POST"
                              />
                            </div>{" "}
                            <table
                              width="100%"
                              cellspacing="0"
                              cellpadding="0"
                              class="checklist-table inventory_table sortTable"
                            >
                              <thead>
                                <tr>
                                  <th class="header"> Added By</th>
                                  <th class="header"> Category </th>
                                  <th class="header"> Payee Name </th>
                                  <th class="header"> Contact Name </th>
                                  <th class="header"> Contact Phone </th>
                                  <th class="header"> Contact Email </th>
                                  <th class="header"> Action </th>
                                </tr>
                              </thead>
                              <tbody>
                                {addPayeePendingApprovalData?.finance_payee_temp?.map(
                                  (el) => (
                                    <tr>
                                      <td>
                                        {el?.user?.first_name +
                                          " " +
                                          el?.user?.last_name}
                                      </td>
                                      <td>
                                        {el?.user?.first_name +
                                          " " +
                                          el?.user?.last_name}
                                      </td>
                                      <td>{el?.payee_name}</td>
                                      <td>{el?.contact_name}</td>
                                      <td>{el?.contact_number_1}</td>
                                      <td>{el?.email}</td>
                                      <td>
                                        <a
                                          onClick={() => {
                                            // history.push(
                                            //   "/order/payees/new-payee",
                                            //   {
                                            //     type: "edit",
                                            //     id: el.id,
                                            //   }
                                            // );
                                          }}
                                          class="circle_icon edit_tooltip"
                                        >
                                          <i class="iconSprites edit-icon"></i>
                                        </a>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </form>{" "}
                        </div>
                        <div class="mCSB_scrollTools">
                          <div class="mCSB_draggerContainer">
                            <div
                              class="mCSB_dragger"
                              oncontextmenu="return false;"
                            >
                              <div class="mCSB_dragger_bar"></div>
                            </div>
                            <div class="mCSB_draggerRail"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default AddPayeePendingApproval;
